/* eslint-disable jsdoc/require-returns */
/* eslint-disable jsdoc/require-param-type */
/* eslint-disable jsdoc/require-param-description */
import { LayoutService } from './../../../../services/layout.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Product } from '../../../../interfaces/product.interface';
import { Subject, throwError } from 'rxjs';
import { SiteSearchResult, ServiceNowSearchResult } from '../../../../interfaces/site-search-result.interface';
import { ActivatedRoute, Router } from '@angular/router';
import { SearchService } from '../../../../services/search.service';
import { RequestUtil } from '../../../../utils/request.util';
import { Store } from '@ngrx/store';
import { AppState } from '../../../../store/state/app.state';
import { map, takeUntil } from 'rxjs/operators';
import { ActionTypes as SearchActionTypes } from '../../../../store/actions/search.action';
import { NavigateEvent } from '../search-result/search-result.component';
import { ProductService } from '../../../../services/product.service';
import { User } from '../../../../models/user.model';
import { SEARCH_ARTICLE_URL, SERVER_API_URL } from '../../../../app.constants';
import { setTitleComponent } from 'src/app/utils/titles.util';
import { Title } from '@angular/platform-browser';

interface CommunitySearchResult {
    count: number;
    url: string;
}

// import 'core-js/es7/array';
@Component({
    selector: 'u4-cpp-search',
    templateUrl: './search.component.html',
})
export class SearchComponent implements OnInit, OnDestroy {
    public user: User;
    public product: Product;
    public labels: { [key: string]: string };
    public criteria = { query: null, productId: null };
    public total = 0;
    public result: SiteSearchResult;
    // public knowledgeSearchProductNames: string;
    public communitySearchUrl: string;
    public showUniversity = false;
    public showCatalogs = false;
    public showCases = false;
    public showKnowledge = false;
    public casesUrl: string;
    public serviceCatalogUrl: string;
    public knowledgeArticlesUrl: string;
    public sNowSearch: ServiceNowSearchResult;
    public articleUrl: string;
    public hideAlert = false;
    public universitySearch: any;
    private destroy$: Subject<void> = new Subject();
    private query: string;
    private serverApiUrl: string = SERVER_API_URL;

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private searchService: SearchService,
        private layoutService: LayoutService,
        private requestUtil: RequestUtil,
        private store: Store<AppState>,
        private productService: ProductService,
        private titleService: Title
    ) {
        this.articleUrl = SEARCH_ARTICLE_URL;
        this.store.select(state => state.labels).pipe(
            takeUntil(this.destroy$)
        ).subscribe(labels => {
            this.labels = labels;
            this.titleService.setTitle(setTitleComponent(this.labels['search.title']));
        });
    
    }

    get resultsTitle() {
        const label = this.labels['search.results.title'];
        const result =
      this.total === 1
          ? this.labels['general.result']
          : this.labels['general.results'];
        return label
            .replace('{{name}}', this.user.firstName)
            .replace('{{count}}', this.total.toString())
            .replace('{{result}}', result)
            .replace('{{product}}', this.product.productName);
    }

    get resultsText() {
        const label = this.labels['search.results.intro-text'];
        return label.replace('{{query}}', this.criteria.query as string);
    }

    ngOnInit() {
        this.store
            .select((state) => state.labels)
            .pipe(takeUntil(this.destroy$))
            .subscribe((labels) => (this.labels = labels));

        this.route.queryParamMap
            .pipe(takeUntil(this.destroy$))
            .subscribe((paramMap) => {
                this.query = paramMap.get('query');
                const productId = paramMap.get('productId');
                this.productService.getProduct(productId).subscribe((product) => {
                    this.product = product;
                    this.store
                        .select((state) => state.profile)
                        .subscribe((profile) => {
                            this.user = profile;
                            this.search(this.query, productId);
                            try {
                                this.showUniversity = true; // this.user.permissions.includes('INTUO');
                                const support4u = this.user.permissions.includes('SUPPORT_SERVICE_NOW');
                                if (support4u) {
                                    this.showKnowledge = true;
                                    this.requestUtil.request(this.searchService
                                        .getSupport4USearchCount(this.query, this.user.id)
                                    ).subscribe((response: ServiceNowSearchResult) => {
                                        const casesCount = response.casesCount;
                                        const serviceCatalogCount = response.serviceCatalogCount;
                                        const knowledgeArticlesCount = response.knowledgeArticlesCount;

                                        this.sNowSearch = {
                                            casesCount,
                                            serviceCatalogCount,
                                            knowledgeArticlesCount
                                        };
                                        this.casesUrl = response.casesUrl;
                                        this.serviceCatalogUrl = response.serviceCatalogUrl;
                                        this.knowledgeArticlesUrl = response.knowledgeArticlesUrl;
                                        this.sumTotalResults(this.sNowSearch);
                                        this.showCases = true;
                                        this.showCatalogs = true;
                                        this.showKnowledge = true;
                                        // this.showCatalogs = true;
                                    }, error => {
                                        console.error('f', error);
                                        throwError(error);
                                    });
                                }
                                if (this.showUniversity) {
                 
                                    this.requestUtil.request(this.searchService.getUniversitySearchCountTemporalSolution(this.query))
                                        .subscribe((results: { count: number; url: string}) => {
                                            if (results.count === -1){
                                                this.showUniversity = false;
                                                results.url = '';
                                            }
                        
                                            this.universitySearch = {

                                                count: results.count,
                                                url: results.url,
                                            };
                                        });
                                }
                
                            } catch (e: unknown) {
                                console.error('Error in University or SN call', (e as Error).message);
                            }
                        });
                });
            });
    }

    ngOnDestroy() {
        this.clearHeaderSearchBar();
        this.destroy$.next();
        this.destroy$.complete();
    }


    /**
     * Search content based on the given query parameters.
     * @param query
     * @param productId
     */
    search(query: string, productId: string): void {
        this.layoutService.loaded$
            .pipe(takeUntil(this.destroy$))
            .subscribe((assetsLoaded) => {
                if (assetsLoaded) {
                    this.fillHeaderSearchBar(query, productId);
                }
            });

        if (!query || !productId) {
            return; // incomplete request
        }

        if (
            query === this.criteria.query &&
      productId === this.criteria.productId
        ) {
            return; // redundant request
        }
        // fetch results
        const request$ = this.requestUtil.request(
            this.searchService.getCombinedSearchCount(query, productId).pipe(
                map(
                    // ([cppResult, knowledgeResult, communityResult]) => {
                    ([cppResult, communityResult]) => {
                        this.criteria = { query, productId }; // persist search criteria
                        return this.parseResults(
                            cppResult,
                            // knowledgeResult,
                            communityResult as CommunitySearchResult,
                        );
                    }
                )
            )
        );

        // handle response
        request$.subscribe((result: unknown) => {
            this.result = Object.assign(result, this.result);
            this.store.dispatch({
                type: SearchActionTypes.SiteSearchQuery,
                payload: {
                    query: this.criteria.query as string,
                    productId: this.criteria.productId as string,
                    results: result,
                },
            });
        });
    }

    /**
     * Triggered when a result item was clicked.
     * @param event
     * @param openNew
     */
    onSearchNavigate(event: NavigateEvent, openNew = false) {
        if (event.href) {
            if (openNew) {
                window.open(event.href);
            } else {
                window.location.href = event.href;
            }
            return;
        }

        const route = this.getRouteBySlug(event.slug);

        if (!route) {
            return; // route not found
        }


        const search = {
            query: this.criteria.query as string,
            productId: this.criteria.productId as string,
            results: this.result,
        };

        this.store.dispatch({
            type: SearchActionTypes.SiteSearchNavigate,
            payload: { category: event.slug, search },
        });

        if (openNew){
            const path = new URL(this.serverApiUrl.concat(route.toString()));
            path.searchParams.set('query', this.criteria.query as string);      
            window.open(path.href);
        }
    }
    
    fillHeaderSearchBar(query: string, productId: string): void {
        window.Unit4Header.setQuery(query, productId);
    }

    clearHeaderSearchBar(): void {
        window.Unit4Header.clearQuery();
    }

    /**
     * Parse the search results.
     * @param cppResult
     * @param communityResult
     */
    private parseResults(
        cppResult,
        // knowledgeResult,
        communityResult: CommunitySearchResult,
    ): SiteSearchResult {
        const counts: SiteSearchResult = Object.assign(
            {
                // knowledgeSearch: knowledgeResult.count,
                communitySearch: communityResult.count,
            },
            cppResult
        ) as SiteSearchResult;
        // sum up result counts
        this.sumTotalResults(counts);
        // store resource-specific data
        // this.knowledgeSearchProductNames =
        //   knowledgeResult.salesforceProductNames || [];
        this.communitySearchUrl = communityResult.url;
        return counts;
    }

    /**
     * Get the resource route based on the specified slug.
     * @param slug
     */
    private getRouteBySlug(slug: string): string | null {
        switch (slug) {
        // case 'knowledge-search':
        //   return this.getProductRoute('knowledge-base');
        case 'product-documentation':
            return this.getProductRoute('documentation');
        case 'product-downloads':
            return this.getProductRoute('software');
        case 'product-news':
            return this.getProductRoute('news');
        case 'general-news':
            return '/news';
        }

        return null;
    }

    /**
     * Get the route to a specific result resource.
     * @param path
     */
    private getProductRoute(path: string): string {
        return `my-solutions/${this.product.slug}/${this.product.contentId}/${path}`;
    }

    private sumTotalResults(counts: any) {
        this.total += Object.keys(counts as any[])
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            .map((key) => counts[key] as number)
            .reduce((acc, count) => acc + (count > 0 ? count : 0), 0);
    }
}
